import cookieService from './cookies'

// Cookiebot event handling: https://www.cookiebot.com/en/developer/#h-event-handling

const CONSENT_COOKIE = 'CookieConsent'
const CONSENT_READY_EVENT = 'CookiebotOnConsentReady'

export const hasConsentResponse = (): boolean => !!cookieService.getItem(CONSENT_COOKIE)

export const onConsentReady = (callback: () => void): void => {
  try {
    if (hasConsentResponse()) {
      callback()
      return
    }

    window.addEventListener(CONSENT_READY_EVENT, callback, { once: true })
  } catch (error) {
    // Consent state unreadable - run the callback instead of blocking it forever.
    console.error('Could not subscribe to the cookie consent state:', error)
    callback()
  }
}
